import React from "react";
import { getCountries, getCountryCallingCode } from "react-phone-number-input";
import { CountryCode } from "libphonenumber-js";
import { AiFillCaretDown } from "react-icons/ai";
import styles from "../../styles/phone_input/country_select.module.scss";
import classNames from "classnames";

interface CountrySelectProps {
  value?: string;
  onChange: (value?: string) => void;
  labels: Record<string, string>;
  className?: string;
}

const CountrySelect = ({
  value,
  onChange,
  labels,
  className,
}: CountrySelectProps) => {
  const options = React.useMemo(() => {
    const countries = getCountries();

    const countryEntries = countries.map((countryCode) => ({
      code: countryCode,
      label: labels[countryCode],
    }));

    // Exclude undefined empty labels
    const validCountries = countryEntries.filter((country) =>
      Boolean(country.label),
    );

    const sortedCountries = validCountries.sort((a, b) =>
      a.label.localeCompare(b.label),
    );

    return sortedCountries;
  }, [labels]);

  return (
    <div className={classNames(styles.fieldGroup, className)}>
      <select
        value={value}
        onChange={(event) => onChange(event.target.value || undefined)}
        className={styles.field}
      >
        {options.map(({ code, label }) => (
          <option key={code} value={code}>
            {label}
          </option>
        ))}
      </select>

      <img
        src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${value}.svg`}
        alt={value}
        className={styles.flag}
      />

      <div className={styles.caret}>
        <AiFillCaretDown />
      </div>

      <div className={styles.countryCode}>
        {value ? `+${getCountryCallingCode(value as CountryCode)}` : ""}
      </div>
    </div>
  );
};

export default CountrySelect;
